/**
 * @author Karthik <karthik.x@314ecorp.com>
 * @description Client
 */

import AxiosClient from './AxiosClient';

const client = new AxiosClient();
export default client;
